import {CompanyReportScreen} from "./ProductsReports.jsx";
export default function ProductionReports(){return <CompanyReportScreen kind="production"/>;}
